export default "__VITE_ASSET__BAuj$HlM__"